export type TextPart = { text: string; href?: string };

// http(s)://… or www.…; anything else (javascript:, data:, mailto:) stays plain text.
const URL_RE = /\b(?:https?:\/\/|www\.)[^\s<>"]+/gi;
// Punctuation that usually ends the sentence rather than the address.
const TRAILING = /[.,;:!?¡¿'")\]}]+$/;

/** Splits chat text into plain pieces and links that are safe to open. */
export function splitLinks(text: string): TextPart[] {
  const parts: TextPart[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_RE)) {
    let url = match[0];
    const trail = url.match(TRAILING)?.[0] ?? '';
    // Keep a closing parenthesis that belongs to the address, as in Wikipedia links.
    let cut = trail.length;
    if (trail.includes(')')) {
      const open = (url.match(/\(/g) ?? []).length;
      const close = (url.match(/\)/g) ?? []).length;
      if (open >= close) cut = 0;
    }
    if (cut) url = url.slice(0, -cut);
    if (/^(https?:\/\/|www\.)$/i.test(url)) continue;
    const start = match.index!;
    if (start > last) parts.push({ text: text.slice(last, start) });
    parts.push({ text: url, href: /^www\./i.test(url) ? `https://${url}` : url });
    last = start + url.length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
}
